import { jsx } from "react/jsx-runtime";
import { c as classNames } from "../../index-CweZ_OcN.js";
import './styles.css';const Icon = ({
  markup,
  name,
  size,
  color,
  rawColor,
  className,
  onClick
}) => {
  const iconStyle = {
    ...rawColor && { color: rawColor }
  };
  const componentClass = classNames("au-icon", {
    [`au-icon--${name == null ? void 0 : name.toLocaleLowerCase()}`]: !!name,
    "au-icon--color-raw": !!rawColor,
    "au-icon--color-dark": color === "dark",
    "au-icon--color-info": color === "info",
    "au-icon--size-large": size === "large",
    "au-icon--size-small": size === "small",
    [`${className}`]: !!className
  });
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: iconStyle,
      onClick,
      className: componentClass,
      dangerouslySetInnerHTML: {
        __html: markup || ""
      }
    }
  );
};
export {
  Icon as default
};
//# sourceMappingURL=index.es.js.map
